import { centsClient } from '../../api/cents/clients/cents-client'
import { Log } from '../../types/usage/log'

let dataQueue: Log[] = []

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const throttled = <T extends (...args: any[]) => Promise<void>>(func: T, limit: number | (() => number)): ((...args: Parameters<T>) => void) => {
  let lastFunc: NodeJS.Timeout
  let lastRan: number

  return (...args: Parameters<T>): void => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const context = this
    const limitValue = typeof limit === 'number' ? limit : limit.apply(context)

    if (!lastRan) {
      void func.apply(context, args)
      lastRan = Date.now()
    } else {
      clearTimeout(lastFunc)
      lastFunc = setTimeout(
        () => {
          if (Date.now() - lastRan >= limitValue) {
            void func.apply(context, args)
            lastRan = Date.now()
          }
        },
        limitValue - (Date.now() - lastRan)
      )
    }
  }
}

const sendData = throttled(async (): Promise<void> => {
  if (dataQueue.length <= 0) return
  try {
    const data = dataQueue
    dataQueue = [] // TODO: This should be done after the request is successful. If the request fails, the data will be lost.
    await centsClient.logs.log(data)
  } catch (e) {
    console.error(e)
  }
}, 100)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sendLogs = (data: Log): void => {
  void (async (): Promise<void> => {
    dataQueue.push(data)
    sendData()
  })()
}
